// Demo storage — IndexedDB only, no API calls

const DB_NAME = 'options-tracker-demo';
const DB_VERSION = 1;
const STORE_NAME = 'trades';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'uid' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function loadTrades() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const req = store.getAll();
    req.onsuccess = () => resolve((req.result || []).filter(t => !t.deleted));
    req.onerror = () => reject(req.error);
  });
}

// Simulate network latency for realism
const fakeDelay = () => new Promise(r => setTimeout(r, 300 + Math.random() * 400));

export async function saveTrades(trades) {
  await fakeDelay();
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  for (const t of trades) store.put(t);
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function addTrade(tradeData) {
  await fakeDelay();
  const trade = {
    ...tradeData,
    uid: tradeData.uid || generateUID(),
    updatedAt: Date.now(),
    deleted: false,
  };
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  tx.objectStore(STORE_NAME).put(trade);
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve({ trade, synced: false });
    tx.onerror = () => reject(tx.error);
  });
}

export async function deleteTrade(uid) {
  await fakeDelay();
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  tx.objectStore(STORE_NAME).delete(uid);
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve({ synced: false });
    tx.onerror = () => reject(tx.error);
  });
}

export async function seedDemoData(trades) {
  const existing = await loadTrades();
  if (existing.length > 0) return false; // already seeded
  await saveTrades(trades);
  return true;
}

export function generateUID() {
  return 'xxxx-xxxx-xxxx'.replace(/x/g, () => Math.floor(Math.random() * 16).toString(16));
}

export function ensureFields(trades) {
  return trades.map(t => ({
    ...t,
    uid: t.uid || generateUID(),
    updatedAt: t.updatedAt || Date.now(),
    deleted: t.deleted || false,
  }));
}

// Stubs for compatibility
export function forceSync() { return Promise.resolve({ synced: false }); }
export function onConnectivityChange(cb) { const h = () => cb(navigator.onLine); window.addEventListener('online', h); window.addEventListener('offline', h); return () => { window.removeEventListener('online', h); window.removeEventListener('offline', h); }; }
let _demoToken = null;
export function setAuthToken(t) { _demoToken = t; }
export function getAuthToken() { return _demoToken; }
export function clearAuthToken() { _demoToken = null; }
export function startVersionPolling() {}
export function stopVersionPolling() {}
export function onTradesChanged(cb) { return () => {}; }
